// src/components/intake/ClientHome.jsx
import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import { getStage } from "../../shared/_services/onboarding.services";
import ClientDashboard from "../dashboard-flow/ClientDashboard";
import DashboardHeader from "../dashboard-flow/DashboardHeader";
import Loader from "../Loader";
import { landingFor } from "../onboarding/onboardingNav";
import IntakeDashboard from "./IntakeDashboard";
import PlanNotice from "../plan/PlanNotice";

// The client's /dashboard, chosen by the stage read (decision 17), never by
// "no answers". While the read is in flight: the header and a loader — never
// the full layout flashing before the stage is known. A failed read: the full
// layout, navigating nowhere (a stage we cannot read must not bounce the
// client; R173 spirit). The order of stages is the served one (R129): before
// intake → the client's own page; at intake → the pass and answer cards; past
// intake → the full dashboard. A stage the server does not list → the full
// dashboard (R208: no route that could name this page again). SP5: the plan
// notice (owner item 20) sits above either layout.
const withNotice = (layout) => (
  <>
    <PlanNotice />
    {layout}
  </>
);

export default function ClientHome() {
  const { user } = useAuth();
  const [stage, setStage] = useState({ status: "loading", data: null });
  const read = useCallback(async () => {
    try {
      const res = await getStage();
      setStage({ status: "ok", data: res.data });
    } catch (_) {
      setStage({ status: "failed", data: null });
    }
  }, []);
  useEffect(() => {
    read();
  }, [read]);

  if (stage.status === "loading") {
    return (
      <>
        <DashboardHeader />
        <Loader />
      </>
    );
  }
  if (stage.status === "failed") return withNotice(<ClientDashboard />);

  const keys = (stage.data.stages || []).map((s) => s.key);
  const pageAt = keys.indexOf("intake");
  const clientAt = keys.indexOf(stage.data.stage);
  if (pageAt === -1 || clientAt === -1 || clientAt > pageAt) {
    return withNotice(<ClientDashboard />);
  }
  if (clientAt === pageAt)
    return withNotice(<IntakeDashboard stage={stage.data} />);
  const to = landingFor(stage.data, user);
  return to === "/dashboard" ? (
    withNotice(<ClientDashboard />)
  ) : (
    <Navigate to={to} replace />
  );
}
